import { Chart } from 'react-chartjs-2';

import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  type ChartOptions,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';
import { formatDate } from 'enable-ui';

import { type OnboardingResult } from 'modules/learners/core/type';
import { getOnboardingMaxScore, getOnboardingTotalScore } from 'modules/learners/utils';

import { cloneDeep } from 'lodash';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
);

export function ResultChart({ results }: { results: OnboardingResult[] }) {
  const chartResults = cloneDeep(results).reverse();

  const options: ChartOptions<'bar'> = {
    responsive: true,
    plugins: {
      legend: {
        align: 'end',
        maxHeight: 400,
        fullSize: true,
        title: {
          padding: 40,
          color: '#808080',
        },
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        ticks: {
          color: '#808080',
        },
        position: 'left',
      },
      y1: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10,
          color: '#808080',
        },
        position: 'right',
        grid: {
          display: false,
        },
      },
      x: {
        beginAtZero: true,
        ticks: {
          color: '#808080',
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const labels = chartResults.map((el) => formatDate(el.updatedAt, 'dd MMM'));

  const data = {
    labels,
    datasets: [
      {
        type: 'bar',
        label: 'Score',
        backgroundColor: '#FD8A24',
        data: chartResults.map((el) => getOnboardingTotalScore(el)),
        borderWidth: 0,
        barThickness: 14,
        borderRadius: 6,
        yAxisID: 'y',
      },
      {
        type: 'line' as const,
        label: '% of max score',
        fill: false,
        borderColor: '#383ECD',
        data: chartResults.map((el) =>
          Math.round((getOnboardingTotalScore(el) / getOnboardingMaxScore(el)) * 100),
        ),
        yAxisID: 'y1',
        borderWidth: 3,
      },
    ],
  };

  return <Chart options={options} type="bar" data={data as any} />;
}
